import * as React from "react";
import { Tooltip, TypographyStack } from "@bolteu/kalep-react";
import ArrowDown from "@bolteu/kalep-react-icons/dist/ArrowDown";
import ArrowUp from "@bolteu/kalep-react-icons/dist/ArrowUp";
import InfoCircle from "@bolteu/kalep-react-icons/dist/InfoCircle";
import ReorderVert from "@bolteu/kalep-react-icons/dist/ReorderVert";
import { cx } from "../utils/cx";
import { ColumnFilter } from "./ColumnFilter";
export function ColumnHeaderText({ children, tooltip, tooltipProps }) {
    const headerContent = (React.createElement(TypographyStack, { primaryTypographyProps: {
            fontWeight: "semibold",
            variant: "body-secondary",
            lines: 2,
            inlineStyle: { lineHeight: "1rem" },
        } }, children));
    if (!tooltip) {
        return headerContent;
    }
    return (React.createElement("div", { className: cx("inline-flex items-center") },
        headerContent,
        React.createElement(Tooltip, Object.assign({ placement: "top", content: tooltip }, tooltipProps),
            React.createElement("div", { className: cx("flex items-center p-1 shrink-0") },
                React.createElement(InfoCircle, { size: "xs", className: cx("text-primary") })))));
}
export function ColumnSort({ dir }) {
    let Icon;
    if (dir === "ASC") {
        Icon = ArrowUp;
    }
    else if (dir === "DESC") {
        Icon = ArrowDown;
    }
    else {
        Icon = ReorderVert;
    }
    return (React.createElement(Icon, { size: "md", 
        // FIXME: these non-existent color classes...
        className: cx("text-graphic-secondary group-hover:text-graphic-primary", dir && "text-graphic-primary") }));
}
export function ColumnHeaderContent({ children, tooltip, compact, align, tooltipProps, width, columnKey, column, sortable, sortDir, onFilterChange, }) {
    return (React.createElement("div", { className: cx("flex gap-2 items-center h-full", compact ? "p-1 min-h-8" : "min-h-12 px-3", sortable && "cursor-pointer", sortDir ? "bg-neutral-secondary" : "bg-special-nulled", align === "right" ? "justify-end" : "justify-between") },
        React.createElement(ColumnHeaderText, { tooltip: tooltip, tooltipProps: tooltipProps }, children),
        React.createElement(ColumnHeaderActions, { columnKey: columnKey, filter: column.filter, sortable: column.sortable, columnWidth: width, sortDir: sortDir, onFilterChange: onFilterChange })));
}
export function ColumnHeaderActions({ columnKey, columnWidth, sortable, sortDir, filter, onFilterChange, }) {
    const hasActions = sortable || filter;
    if (!hasActions) {
        return null;
    }
    return (React.createElement("div", { className: cx("flex items-center shrink-0 gap-2") },
        sortable && React.createElement(ColumnSort, { dir: sortDir }),
        filter && (React.createElement(ColumnFilter, { columnKey: columnKey, filter: filter, width: columnWidth, onFilterChange: onFilterChange }))));
}
